import { render, staticRenderFns } from "./teams.vue?vue&type=template&id=01b5cf0a&scoped=true"
import script from "./teams.vue?vue&type=script&lang=js"
export * from "./teams.vue?vue&type=script&lang=js"
import style0 from "./teams.vue?vue&type=style&index=0&id=01b5cf0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b5cf0a",
  null
  
)

export default component.exports